import axios from "axios";

/*
 * ---------------------------------------------------------------------
 * import Action types
 * ---------------------------------------------------------------------
 */
import {
    SET_TOKEN,
    SET_TOKEN_VALID,
} from "./types";

import {
    setError
} from "src/shared_modules/veu-visitors-core/actions/system";

import { getConfig } from "src/config/axios";
/*
 * ---------------------------------------------------------------------
 * internal Actions
 * ---------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------
 * Public Actions
 * ---------------------------------------------------------------------
 */
export const setToken = ( token ) => ({
    type: SET_TOKEN,
    payload: token
});

export const setTokenValid = ( isTokenValid ) => ({
    type: SET_TOKEN_VALID,
    payload: isTokenValid
});

/*
 * ---------------------------------------------------------------------
 * async thunks
 * ---------------------------------------------------------------------
 */
export const fetchToken = ( mail, lang, data ) => {
    return async ( dispatch, getState ) => {
        //console.log("fetchPollVoting " );
        let axiosconf = getConfig().veu;
        let url = "/account/token/create/" + mail + "/" + lang;
        let headers = axiosconf.headers;

        dispatch( setError(null) );

        const done = await axios.post(url,
            data, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            //console.log( JSON.stringify(response, null,2) );
            if (response.status === 200) {
                dispatch( setToken(response.data.token) );
                //console.log("fetchToken:  "+JSON.stringify(response.data));
            }
        })
        .catch( (error) => {
            dispatch( setError( error.response ) );
        });
        return done;
    }
}

export const validateToken = ( token, code ) => {
    return async ( dispatch, getState ) => {
        //console.log("fetchPollVoting " );
        let axiosconf = getConfig().veu;
        let url = "/account/token/validate/" + token + "/" + code;
        let headers = axiosconf.headers;

        dispatch( setError(null) );

        const done = await axios.get(url, {
            // options
            crossDomain: true,
            headers: headers
        })
        .then( (response) => {
            //console.log( JSON.stringify(response, null,2) );
            if (response.status === 200) {
                dispatch( setTokenValid(response.data.success) );
                //console.log("validateToken:  "+JSON.stringify(response.data));
            }
            else {
              dispatch( setTokenValid(false) );
            }
        })
        .catch( (error) => {
            dispatch( setTokenValid(false) );
        });
        return done;
    }
}
